import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
	hasObraChecklistServico: boolean;
	onActionEdit: (idChecklistServicoAmbiente: number | null, openState: boolean) => void,
	onActionDelete: (idChecklistServicoAmbiente: number | null, openState: boolean) => void,
	onActionCopia: (idChecklistServicoAmbiente: number | null, openState: boolean) => void,
}

export const GenerateChecklistServicoLiberacaoColumns = ({
	hasObraChecklistServico,
	onActionEdit,
	onActionDelete,
	onActionCopia,

}: Props): GridColDef[] => {
	return [
		{
			field: "ordem",
			filterable: false,
			headerName: "Ordem",
			minWidth: 100,
			width: 120,
			sortable: false,
			renderCell: ({ value }) => (
				<div className="w-full h-full flex items-center gap-2 break-normal">
					<span>{value}</span>
				</div>
			)
		},
		{
			field: "descricao",
			filterable: false,
			headerName: "Descrição",
			flex: 1,
			minWidth: 200,
			sortable: false,
			renderCell: ({ value }) => (
				<div className="w-full h-full flex items-center gap-2 break-normal">
					<span>{value}</span>
				</div>
			)
		},
		{
			field: 'idChecklistServicoLiberacao',
			sortable: false,
			filterable: false,
			headerName: 'Ações',
			headerAlign: 'center',
			width: 115,
			minWidth: 115,
			renderCell: (params) => {
				return (
					<div className="flex items-center justify-center w-full h-full">
						<IconButton onClick={() => onActionEdit(params.value, true)}>
							<DynamicIcon nameIcon="EditRounded" size={20} className="dark:text-white text-primary-green" />
						</IconButton>
						{
							!hasObraChecklistServico &&
							<IconButton onClick={() => onActionDelete(params.value, true)}>
								<DynamicIcon nameIcon="DeleteForeverRounded" size={20} className="text-red-500" />
							</IconButton>
						}
						{
							!hasObraChecklistServico &&
							<IconButton onClick={() => onActionCopia(params.value, true)}>
								<DynamicIcon nameIcon="ContentCopyRounded" size={20} className="text-purple-500 dark:text-white" />
							</IconButton>
						}
					</div>
				);
			}
		}
	];
}